import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  max-width: 398px;
  height: 224px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;

  span {
    display: block;
  }

  @media only screen and (max-width: 1360px) {
    max-width: unset;
  }
`;
